'use client';

import { Box, Button, Container, Typography, type SxProps } from '@mui/material';
import { flatSx, FlexRow } from '@ocodelib/mui';
import clsx from 'clsx';
import React from 'react';
import { PageBanner } from '../../components/PageBanner';
import { LinkI18n, useRouterI18n } from '../../i18n/routing';

const BANNER_TINT = '#92D050';
const BANNER_BACKGROUND = '#121212';

const BANNER_TABS = [
  { key: 'block', label: '블록코딩' },
  { key: 'text', label: '텍스트코딩' },
] as const;

type TabKey = (typeof BANNER_TABS)[number]['key'];

interface Props {
  sx?: SxProps;
  className?: string;
  tab?: TabKey;
  title?: React.ReactNode;
  children?: React.ReactNode | ((tabKey: TabKey) => React.ReactNode);
}

export default function CodingListLayout(props: Props) {
  const { sx, className, title, children } = props;
  const tabKey = BANNER_TABS.find((it) => it.key === props.tab)?.key ?? 'text';
  const router = useRouterI18n();

  return (
    <Box
      className={clsx('CodingListLayout-root', className)}
      sx={flatSx(
        {
          pb: 10,
        },
        sx,
      )}
    >
      <PageBanner
        title="코딩"
        tint={BANNER_TINT}
        background={BANNER_BACKGROUND}
        contrastColor="#222"
        bgImgSrc="/_static/images/page-banner/top_banner3.png"
        tabKey={tabKey}
        tabs={BANNER_TABS}
        breadcrumbProps={{
          tint: '#fff',
          section: '코딩',
          subSection: '코딩하기',
          currentTitle: BANNER_TABS.find((it) => it.key === tabKey)?.label ?? tabKey,
        }}
        onChangeTab={(_, value) => {
          router.push('/coding/list/' + value);
        }}
      />
      <Typography variant="h5" textAlign="center" sx={{ mt: '60px', mb: '30px' }}>
        {title}
      </Typography>

      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          background: '#fff',
        }}
      >
        <FlexRow justifyContent="flex-end" sx={{ mb: 2, color: '#7ec72b' }}>
          <Button variant="outlined" color="primary" LinkComponent={LinkI18n} href="/coding/mine">
            나의 코딩
          </Button>
        </FlexRow>
        {typeof children === 'function' ? children(tabKey) : children}
      </Container>
    </Box>
  );
}
